import React from 'react';
import { Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../helper/appRoutes';
import useAuth from '../context/AuthProvider';
import { DashboardTile } from '../components/Elements/DashboardTile';


export const AdminIWantTo: React.FC = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    
    const IWantToItems = [
        {
            icon: <></>,
            title: 'Request a Signature',
            onClick: () => {
                navigate(AppRoutes.home.requestSignature);
            },
            variant: 'primary',
        },
        {
            icon: <></>,
            title: 'Send a Stamped Document',
            onClick: () => {
                navigate(AppRoutes.home.sendStampedDocument);
            },
            variant: 'primary',
        },
        {
            icon: <></>,
            title: 'Report a Tag',
            onClick: () => {
                navigate(AppRoutes.home.reportTag);
            },
            variant: 'primary',
        },
        {
            icon: <></>,
            title: 'Go to Diligent Search Library',
            onClick: () => {
                navigate(AppRoutes.home.diligentSearchLibrary);
            },
            variant: 'primary',
        }
    ];
    return (
        <Box sx={{ maxWidth: '800px', margin: '0 auto' }}>
            <Grid container spacing={3}>
                {IWantToItems.map((page, idx) => {
                    return (
                        <Grid item xs={12} sm={6} md={6} key={idx}>
                            <DashboardTile
                                icon={page.icon}
                                title={page.title}
                                onClick={page.onClick}
                                variant="primary"
                            />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};
export default AdminIWantTo;